import { ENDPOINT, requestOptions } from '../utils/settings'

export async function recommendedProperties(span: string, spanDepth:string): Promise<any> {
    const myHeaders = new Headers()
    myHeaders.append('Accept', 'application/json')
    myHeaders.append('Content-type', 'application/json')
    const properties = await fetch(`${ENDPOINT}/pdf/recommended-properties`, {
        ...requestOptions,
        method: 'POST',
        body: JSON.stringify({ span, spanDepth }),
        headers: myHeaders,
        redirect: 'follow'
    }).then(response => response.json())

    return properties
}
